import * as types from './complianceSalesActionTypes';
import { ComplianceSalesActionKeys as keys } from './complianceSalesActionKeys';
import { ISalesComplianceResponse } from '.';

export const salesComplianceActionCreators = {
  fetch: (): types.FetchSalesCompliance => ({
    type: keys.FETCH_SALES_COMPLIANCE
  }),
  set: (payload: ISalesComplianceResponse): types.SetSalesCompliance => ({
    payload,
    type: keys.SET_SALES_COMPLIANCE
  }),
  toggleLoading: (): types.ToggleSalesComplianceLoading => ({ type: keys.TOGGLE_SALES_COMPLIANCE_LOADING })
};
